<template>
  <div class="w-full h-full flex align-center justify-center lg:col-6 md:col-12">
    <SmartModal type="warning" icon="warning" buttonText="ok" routerRedirect='Login' title="">
      Usuário, agora é necessário informar Login e senha de acesso ao Tim Smart para acessar o termo. Caso não tenha ou não lembre sua senha,
      solicite um Reset de senha pelo link Esqueci minha senha.
    </SmartModal>
  </div>
</template>
<script>
// @flow
export default {
  name: 'ConsumerInfor'
};
</script>
